export default {
  nativeAdLabel: 'Label.SponsoredAd'
};
